'use strict';

+function ($) {

  $.fn.radio = function () {
    // handle radios wrapped in labels (without for="#id") on page load
    return this
    .find(':radio')
    .addBack(':radio')
    .each(function () {
      var $radios = $('label input:radio[name="' + $(this).attr('name') + '"]');
      $radios.each(function () {
        $(this).closest('label').toggleClass('checked', $(this).is(':checked'));
        $(this).closest('label').toggleClass('disabled', $(this).is(':disabled'));
      });
    });
  };

  $(document)
  // update radio label on change
  .on('change.bc.radio', 'input:radio', function (e) {
    var $input = $(e.target);
    var $radios = $input;
    if ($input.attr('name')) {
      $radios = $('label input:radio[name="' + $input.attr('name') + '"]');
    } else if ($input.closest('.form-group').length > 0) {
      $radios = $input.closest('.form-group').find('input:radio');
    }
    $radios.each(function () {
      $(this).closest('label').toggleClass('checked', $(this).is(':checked'));
    });
  });

  basecoat.init.radio = function () {
    $(this).radio();
  };

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/radio.js
// module id = 14
// module chunks = 0